var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar"},[_c('h2',[_vm._v("Document requests")]),_c('ul',{staticClass:"nav nav-stacked"},_vm._l((_vm.requests),function(request){return _c('request-item-view',{key:request.id,attrs:{"request":request,"active":_vm.isActive(request)},on:{"activate":function($event){return _vm.$emit('activate', request.id)}}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }